import { call, CallEffect, put, PutEffect, takeEvery } from 'redux-saga/effects';

import { wordBoundaries as fetchWordBoundaries } from 'js/shared/helpers/app-services/AppServices/wordBoundaries';
import {
  getWordBoundariesFailure,
  getWordBoundariesRequested,
  getWordBoundariesSuccess
} from 'js/reducers/audioWordformsReducer';
import { WordBoundary } from 'js/types';
import { showError } from 'js/actionCreators/uiActions';

function* loadWordBoundariesSaga({
  payload
}: ReturnType<typeof getWordBoundariesRequested>): Generator<
  CallEffect<WordBoundary[]> | PutEffect,
  void,
  WordBoundary[]
> {
  const { assetId } = payload;

  try {
    const boundaries = (yield call(fetchWordBoundaries, assetId)) as WordBoundary[];
    yield put(getWordBoundariesSuccess({ assetId, wordBoundaries: boundaries }));
  } catch (error) {
    if (error instanceof Error) {
      yield put(getWordBoundariesFailure({ assetId, error: error.message }));
      yield put(
        showError({
          message: `Failed to initialize wordform for asset id ${assetId}. Please try again later.`,
          description: error.message
        })
      );
    }
  }
}

export default function* audioWordformsSaga() {
  yield takeEvery(getWordBoundariesRequested.type, loadWordBoundariesSaga);
}
